import { render } from "./ReviewHead.vue?vue&type=template&id=0ab0f1d4&scoped=true"
import script from "./ReviewHead.vue?vue&type=script&lang=js"
export * from "./ReviewHead.vue?vue&type=script&lang=js"

import "./ReviewHead.vue?vue&type=style&index=0&id=0ab0f1d4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab0f1d4"]])

export default __exports__